(() => {
  const CONFETTI_COLORS = ['#DE6F7B', '#F4B8C1', '#FFD7A5', '#C9E4DE', '#B9CDE8', '#F7E6A1', '#121212'];

  document.querySelectorAll('.bb').forEach(initBundle);

  function initBundle(root) {
    const moneyFormat = (window.Shopify && window.Shopify.money_format) || '₹{{amount}}';
    const fmt = (cents) => formatMoney(cents, moneyFormat);

    /* ── Read tier + offer data from rendered DOM ── */
    const tierEls = [...root.querySelectorAll('[data-bb-tier]')];
    const tiers = tierEls.map((el, i) => {
      const qty   = parseInt(el.dataset.qty, 10);
      const price = parseFloat(el.dataset.bundlePrice);
      const titleEl = el.querySelector('.bb-stop-top');
      const subEl   = el.querySelector('.bb-stop-bot');
      return {
        qty:  Number.isFinite(qty) ? qty : 0,
        price: Number.isFinite(price) ? price : 0,
        title: titleEl ? titleEl.textContent.trim() : '',
        save:  subEl   ? subEl.textContent.trim()   : '',
        el,
        idx: i,
      };
    }).filter(t => t.qty > 0)
      .sort((a, b) => a.qty - b.qty);

    // Desktop pills are the canonical data source. Mobile pills (.bb-offers-mobile)
    // mirror them visually with the same data attributes; reading from the desktop
    // set only avoids duplicate qty entries in the offers array.
    const offerEls = [...root.querySelectorAll('.bb-offers [data-bb-offer]')];
    const offers = offerEls.map((el, i) => {
      const qty   = parseInt(el.dataset.qty, 10);
      const price = parseFloat(el.dataset.bundlePrice);
      const titleEl = el.querySelector('.bb-offer-title');
      const subEl   = el.querySelector('.bb-offer-sub');
      return {
        qty:  Number.isFinite(qty) ? qty : 0,
        price: Number.isFinite(price) ? price : 0,
        title: titleEl ? titleEl.textContent.trim() : '',
        save:  subEl   ? subEl.textContent.trim()   : '',
        el,
      };
    }).filter(o => o.qty > 0)
      .sort((a, b) => a.qty - b.qty);

    const dataMaxQty = parseInt(root.dataset.maxQty, 10);
    const maxQty = Number.isFinite(dataMaxQty) && dataMaxQty > 0
      ? dataMaxQty
      : (tiers.length ? tiers[tiers.length - 1].qty : 0);

    if (!offers.length || !tiers.length || !maxQty) {
      console.warn('[bundle-builder] No usable offers/tiers found.', {
        offers: offers.length, tiers: tiers.length, maxQty,
        hint: 'Check that the page metafield is set and metaobject field names match the section settings.',
      });
    }

    const state = {
      items: new Map(),         // Stage 1: keyed by variantId → {qty, ...}
      stage2Items: new Map(),   // Stage 2: same shape; separate map keeps states independent
      stage: 'stage1',          // 'stage1' | 'stage2' — drives which view + items render
      maxQty,
      lastReachedIdx: -1,
      confettiEnabled: root.dataset.confetti === 'true',
      // Shopper-clicked offer (target). Auto-derived tier still wins if it's higher.
      manualOffer: null,
    };

    /* ── Bindings ── */
    bindTabs();
    bindOffers();
    bindCardEvents();
    bindClear();
    bindCta();
    bindDrawer();
    bindModal();
    bindSort();
    bindSearch();
    bindStageTransitions();
    bindKeyboardHide();

    // Honour ?prefill=<variantId>[,<variantId>...] from a product-page banner.
    // Each id, if matched against a card in the grid, is added (subject to cap).
    applyPrefillFromUrl();

    function applyPrefillFromUrl() {
      try {
        const raw = new URLSearchParams(window.location.search).get('prefill');
        if (!raw) return;
        const ids = raw.split(',').map(s => s.trim()).filter(Boolean);
        ids.forEach(id => {
          const card = root.querySelector(`[data-bb-card][data-variant-id="${id}"]`);
          if (card && (!state.maxQty || totalQty() < state.maxQty)) {
            onAddClick(card);
          }
        });
      } catch (_) { /* no-op */ }
    }

    // Defer first render until after the browser has had a chance to paint
    // the static HTML. The static DOM is already valid (Liquid-driven), so
    // delaying the JS pass keeps interaction perceived-fast.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(render, { timeout: 200 });
    } else {
      requestAnimationFrame(render);
    }

    /** Tabs swap which <section data-bb-category> is visible. Only one
     *  category is rendered at a time (no accordion expand/collapse). */
    function bindTabs() {
      root.querySelectorAll('[data-bb-tab]').forEach(tab => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.bbTab;
          root.querySelectorAll('.bb-tab').forEach(t => {
            const active = t.dataset.bbTab === id;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          // If a search query is active, tab clicks don't change visibility —
          // the search filter is in charge. The active tab class still updates
          // so the shopper sees their intent acknowledged when they clear the
          // search later.
          const searchInput = root.querySelector('[data-bb-search]');
          const hasSearch = searchInput && searchInput.value.trim() !== '';
          if (!hasSearch) {
            root.querySelectorAll('[data-bb-category]').forEach(sec => {
              sec.hidden = sec.dataset.bbCategory !== id;
            });
            const target = root.querySelector(`[data-bb-category="${id}"]`);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    /** Search filter — input non-empty switches into "global filter mode":
     *  every category section shows if it contains ≥1 matching card; cards
     *  with non-matching titles are hidden. Empty input restores tab-driven
     *  visibility (only active tab's section visible). */
    function bindSearch() {
      const input = root.querySelector('[data-bb-search]');
      if (!input) return;
      const emptyMsg = root.querySelector('[data-bb-search-empty]');
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        const inStage2 = state.stage === 'stage2';
        const sections = root.querySelectorAll('[data-bb-category]');
        const stage2Grid = root.querySelector('[data-bb-stage2-grid]');
        let totalMatches = 0;

        if (!q) {
          // Empty query → restore default visibility for the active stage.
          if (inStage2) {
            // Stage 2 is a single flat grid — every card visible.
            if (stage2Grid) {
              stage2Grid.querySelectorAll('[data-bb-card]').forEach(c => { c.hidden = false; });
            }
          } else {
            // Stage 1 → tab-driven section visibility, all cards shown.
            const activeTab = root.querySelector('.bb-tab.is-active');
            const activeId = activeTab ? activeTab.dataset.bbTab : null;
            sections.forEach(sec => {
              sec.hidden = activeId ? sec.dataset.bbCategory !== activeId : false;
              sec.querySelectorAll('[data-bb-card]').forEach(c => { c.hidden = false; });
            });
          }
          if (emptyMsg) emptyMsg.hidden = true;
          return;
        }

        // Non-empty query → title-substring filter inside the active stage.
        if (inStage2) {
          if (stage2Grid) {
            stage2Grid.querySelectorAll('[data-bb-card]').forEach(c => {
              const title = (c.dataset.title || '').toLowerCase();
              const matches = title.includes(q);
              c.hidden = !matches;
              if (matches) totalMatches++;
            });
          }
        } else {
          sections.forEach(sec => {
            let anyMatch = false;
            sec.querySelectorAll('[data-bb-card]').forEach(c => {
              const title = (c.dataset.title || '').toLowerCase();
              const matches = title.includes(q);
              c.hidden = !matches;
              if (matches) { anyMatch = true; totalMatches++; }
            });
            sec.hidden = !anyMatch;
          });
        }
        if (emptyMsg) emptyMsg.hidden = totalMatches > 0;
      });
    }

    function bindSort() {
      const sel = root.querySelector('[data-bb-sort]');
      if (!sel) return;
      const storageKey = `bb-sort-${root.dataset.sectionId || 'default'}`;
      let stored = null;
      try { stored = sessionStorage.getItem(storageKey); } catch (_) { /* SSR / private mode */ }
      if (stored && [...sel.options].some(o => o.value === stored)) {
        sel.value = stored;
        applySort(stored);
      }
      sel.addEventListener('change', () => {
        const v = sel.value;
        try { sessionStorage.setItem(storageKey, v); } catch (_) { /* no-op */ }
        applySort(v);
      });
    }

    function applySort(mode) {
      const grids = root.querySelectorAll('.bb-products');
      let cmp;
      switch (mode) {
        case 'title-asc':
          cmp = (a, b) => (a.dataset.title || '').toLowerCase().localeCompare((b.dataset.title || '').toLowerCase());
          break;
        case 'title-desc':
          cmp = (a, b) => (b.dataset.title || '').toLowerCase().localeCompare((a.dataset.title || '').toLowerCase());
          break;
        case 'price-asc':
          cmp = (a, b) => Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
          break;
        case 'price-desc':
          cmp = (a, b) => Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
          break;
        case 'manual':
        default:
          cmp = (a, b) => Number(a.dataset.bbSortIndex || 0) - Number(b.dataset.bbSortIndex || 0);
          break;
      }
      grids.forEach(grid => {
        const cards = [...grid.querySelectorAll('[data-bb-card]')];
        if (cards.length < 2) return;
        cards.sort(cmp);
        // Re-append in sorted order — appendChild on existing nodes moves them.
        const frag = document.createDocumentFragment();
        cards.forEach(c => frag.appendChild(c));
        grid.appendChild(frag);
      });
    }

    function bindOffers() {
      // Event delegation — picks up clicks on both desktop and mobile pills
      // (both have [data-bb-offer]). Match by data-qty back to the canonical offer.
      root.addEventListener('click', (e) => {
        const el = e.target.closest('[data-bb-offer]');
        if (!el || !root.contains(el)) return;
        const qty = parseInt(el.dataset.qty, 10);
        const o = offers.find(off => off.qty === qty);
        if (o) {
          state.manualOffer = o;
          scheduleRender();
        }
      });
    }

    /* Event delegation — survives accordion-open/close, dynamically rendered cards, etc.
       Three branches:
       1. + button click → direct-add to bundle (no modal) UNLESS the product
          has >1 variant, in which case force the modal so the shopper picks one
          before it's added.
       2. <a> link inside the card → suppress nav, open product modal
       3. Tap on card body (not on a button/select/input that has its own handler) → open modal
    */
    function bindCardEvents() {
      root.addEventListener('click', (e) => {
        const card = e.target.closest('[data-bb-card]');
        if (!card || !root.contains(card)) return;

        // 1a. Stepper − button → decrement / remove one of this variant.
        if (e.target.closest('[data-bb-stepper-minus]')) {
          e.preventDefault();
          e.stopPropagation();
          onRemoveClick(card);
          return;
        }

        // 1b. Stepper + button → increment this variant's qty (no modal —
        // the variant is already locked to whatever was previously picked).
        if (e.target.closest('[data-bb-stepper-plus]')) {
          e.preventDefault();
          e.stopPropagation();
          onAddClick(card);
          return;
        }

        // 1c. + button → direct-add, unless the product has multiple variants
        if (e.target.closest('[data-bb-add]')) {
          e.preventDefault();
          e.stopPropagation();
          const variantsCount = parseInt(card.dataset.variantsCount || '1', 10);
          if (isProductInBundle(card)) {
            removeProductFromBundle(card);   // "Added" → tap to remove (toggle off)
          } else if (variantsCount > 1) {
            openProductModal(card);          // pick a variant, then it's added
          } else {
            onAddClick(card);
          }
          return;
        }

        // 2. Link inside the theme's product-card → swap navigation for modal
        const link = e.target.closest('a');
        if (link && card.contains(link)) {
          e.preventDefault();
          e.stopPropagation();
          openProductModal(card);
          return;
        }

        // 3. Tap on card body — but let buttons/selects/inputs handle their own clicks
        if (e.target.closest('button, select, input, textarea, [role="button"]')) return;
        e.preventDefault();
        openProductModal(card);
      });
    }

    /* ── Product detail modal ── */
    let _modalState = { card: null, variantId: null, autoplay: null, variants: [], images: [] };

    function openProductModal(card) {
      const modal = root.querySelector('[data-bb-modal]');
      if (!modal) return;
      const blob = card.querySelector('[data-bb-card-data]');
      if (!blob) return;

      let data;
      try { data = JSON.parse(blob.textContent); } catch (_) { return; }

      const titleEl    = modal.querySelector('[data-bb-modal-title]');
      const descEl     = modal.querySelector('[data-bb-modal-description]');
      const galleryTr  = modal.querySelector('[data-bb-modal-gallery-track]');
      const galleryDot = modal.querySelector('[data-bb-modal-gallery-dots]');
      const variantWr  = modal.querySelector('[data-bb-modal-variant-wrap]');
      const variantsEl = modal.querySelector('[data-bb-modal-variants]');
      const addBtn     = modal.querySelector('[data-bb-modal-add]');
      const addLbl     = modal.querySelector('[data-bb-modal-add-label]');

      _modalState.card = card;
      _modalState.images = data.images || [];
      _modalState.variants = data.variants || [];

      if (titleEl) titleEl.textContent = data.title || '';
      if (descEl) {
        descEl.innerHTML = data.description || '';
        var moreBtn = modal.querySelector('[data-bb-desc-more]');
        // Bind the Read more / Read less toggle once.
        if (moreBtn && !modal._descBound) {
          modal._descBound = true;
          modal.addEventListener('click', function (e) {
            var btn = e.target.closest('[data-bb-desc-more]');
            if (!btn) return;
            var d = modal.querySelector('[data-bb-modal-description]');
            var collapsed = d.classList.toggle('is-collapsed');
            btn.textContent = collapsed ? 'Read more' : 'Read less';
          });
        }
        // Collapse to 5 lines by default; only show the toggle if the text overflows.
        if (moreBtn) {
          descEl.classList.add('is-collapsed');
          moreBtn.hidden = true;
          moreBtn.textContent = 'Read more';
          requestAnimationFrame(function () {
            if (descEl.scrollHeight > descEl.clientHeight + 2) moreBtn.hidden = false;
            else descEl.classList.remove('is-collapsed');
          });
        }
      }

      // Gallery
      if (galleryTr) {
        galleryTr.innerHTML = (data.images || []).map(src =>
          '<li class="bb-modal-gallery-slide"><img src="' + escapeAttr(src) + '" loading="lazy" decoding="async" alt=""></li>'
        ).join('');
        galleryTr.scrollLeft = 0;
      }
      if (galleryDot) {
        galleryDot.innerHTML = (data.images || []).map((_, i) =>
          '<button type="button" class="bb-modal-gallery-dot' + (i === 0 ? ' is-active' : '') + '" data-idx="' + i + '" aria-label="Image ' + (i+1) + '"></button>'
        ).join('');
      }
      // Arrows — only show when the gallery actually has more than one image.
      const navPrev = modal.querySelector('[data-bb-modal-gallery-prev]');
      const navNext = modal.querySelector('[data-bb-modal-gallery-next]');
      const hasMany = (data.images || []).length > 1;
      if (navPrev) navPrev.hidden = !hasMany;
      if (navNext) navNext.hidden = !hasMany;

      // Variants — multi-variant products force a pick (CTA disabled, label
      // "Pick a variant"). Single-variant products pre-fill the id from the
      // card's data-variant-id and the CTA is immediately actionable.
      const variants = data.variants || [];
      if (variants.length > 1 && variantWr && variantsEl) {
        _modalState.variantId = null;
        variantsEl.innerHTML = variants.map(v =>
          '<button type="button" class="bb-modal-variant-pill' +
          (v.available ? '' : ' is-unavailable') +
          '" role="radio" aria-checked="false"' +
          ' data-variant-id="' + v.id + '"' +
          (v.available ? '' : ' disabled aria-disabled="true"') +
          '>' + escapeAttr(v.title) + '</button>'
        ).join('');
        variantWr.hidden = false;
        if (addLbl) addLbl.textContent = 'Pick a variant';
        if (addBtn) addBtn.disabled = true;
      } else {
        if (variantWr) variantWr.hidden = true;
        _modalState.variantId = card.dataset.variantId;
        // Guard: a sold-out single-variant product must not be addable from the
        // modal. The card's + button is HTML-disabled for sold-out, but the card
        // body stays tappable (to view details), so the modal path needs its own
        // check — otherwise adding it would 422 on /cart/add.js after the cart
        // has already been cleared, leaving the shopper with an empty cart.
        const soldOut = variants[0] && variants[0].available === false;
        if (addLbl) addLbl.textContent = soldOut ? 'Sold out' : 'Add to bundle';
        if (addBtn) addBtn.disabled = soldOut;
      }

      // Show + lock body scroll
      modal.hidden = false;
      document.documentElement.dataset.bbScrollLock = '1';
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        // Force the gallery to the first slide AFTER the modal is visible —
        // resetting scrollLeft before the modal had layout was a no-op since
        // the slides were still 0-width, so scroll-snap could land anywhere.
        if (galleryTr) galleryTr.scrollLeft = 0;
      });

      startGalleryAutoplay();
    }

    function closeProductModal() {
      const modal = root.querySelector('[data-bb-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      stopGalleryAutoplay();
      // Wait for fade-out before fully hiding (CSS transition is .2s)
      setTimeout(() => { modal.hidden = true; }, 220);
      delete document.documentElement.dataset.bbScrollLock;
      document.body.style.overflow = '';
      _modalState.card = null;
    }

    function startGalleryAutoplay() {
      stopGalleryAutoplay();
      const track = root.querySelector('[data-bb-modal-gallery-track]');
      if (!track || track.children.length <= 1) return;
      _modalState.autoplay = setInterval(() => {
        if (track.children.length <= 1) return;
        const slideW = track.children[0].getBoundingClientRect().width;
        if (!slideW) return;
        const idx  = Math.round(track.scrollLeft / slideW);
        const next = (idx + 1) % track.children.length;
        track.scrollTo({ left: next * slideW, behavior: 'smooth' });
      }, 3000);
    }
    function stopGalleryAutoplay() {
      if (_modalState.autoplay) { clearInterval(_modalState.autoplay); _modalState.autoplay = null; }
    }

    function bindModal() {
      const modal = root.querySelector('[data-bb-modal]');
      if (!modal) return;

      const galleryTr  = modal.querySelector('[data-bb-modal-gallery-track]');
      const galleryDot = modal.querySelector('[data-bb-modal-gallery-dots]');
      const variantsEl = modal.querySelector('[data-bb-modal-variants]');
      const addBtn     = modal.querySelector('[data-bb-modal-add]');
      const addLbl     = modal.querySelector('[data-bb-modal-add-label]');

      // Close handlers (× button + backdrop)
      modal.querySelectorAll('[data-bb-modal-close]').forEach(el => {
        el.addEventListener('click', closeProductModal);
      });
      // Esc closes
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeProductModal();
      });

      // Gallery — pause autoplay on hover/touch, resume on leave
      if (galleryTr) {
        galleryTr.addEventListener('pointerenter', stopGalleryAutoplay);
        galleryTr.addEventListener('pointerleave', () => {
          if (modal.classList.contains('is-open')) startGalleryAutoplay();
        });
        // Sync active dot on scroll
        galleryTr.addEventListener('scroll', () => {
          if (!galleryTr.children.length || !galleryDot) return;
          const slideW = galleryTr.children[0].getBoundingClientRect().width;
          if (!slideW) return;
          const idx = Math.round(galleryTr.scrollLeft / slideW);
          galleryDot.querySelectorAll('[data-idx]').forEach(d =>
            d.classList.toggle('is-active', parseInt(d.dataset.idx, 10) === idx)
          );
        });
      }

      // Dot clicks → scroll to slide
      if (galleryDot) {
        galleryDot.addEventListener('click', (e) => {
          const dot = e.target.closest('[data-idx]');
          if (!dot || !galleryTr || !galleryTr.children.length) return;
          const slideW = galleryTr.children[0].getBoundingClientRect().width;
          galleryTr.scrollTo({ left: parseInt(dot.dataset.idx, 10) * slideW, behavior: 'smooth' });
        });
      }

      // Prev/next arrows — wrap around at the ends so navigation never dead-ends.
      const navPrev = modal.querySelector('[data-bb-modal-gallery-prev]');
      const navNext = modal.querySelector('[data-bb-modal-gallery-next]');
      function nudgeGallery(dir) {
        if (!galleryTr || !galleryTr.children.length) return;
        const slideW = galleryTr.children[0].getBoundingClientRect().width;
        if (!slideW) return;
        const count = galleryTr.children.length;
        const idx = Math.round(galleryTr.scrollLeft / slideW);
        const next = (idx + dir + count) % count;
        stopGalleryAutoplay();
        galleryTr.scrollTo({ left: next * slideW, behavior: 'smooth' });
        setTimeout(startGalleryAutoplay, 3000);
      }
      if (navPrev) navPrev.addEventListener('click', () => nudgeGallery(-1));
      if (navNext) navNext.addEventListener('click', () => nudgeGallery(1));

      // Variant pills — click to pick; updates state + flips the CTA label
      // from "Pick a variant" → "Add to bundle" and enables the button.
      // Also scrolls the gallery to the variant's own image so the visual
      // matches the selection.
      if (variantsEl) {
        variantsEl.addEventListener('click', (e) => {
          const pill = e.target.closest('[data-variant-id]');
          if (!pill || pill.disabled || pill.classList.contains('is-unavailable')) return;
          variantsEl.querySelectorAll('.bb-modal-variant-pill').forEach(p => {
            p.classList.remove('is-selected');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('is-selected');
          pill.setAttribute('aria-checked', 'true');
          _modalState.variantId = pill.dataset.variantId;
          if (addLbl) addLbl.textContent = 'Add to bundle';
          if (addBtn) addBtn.disabled = false;

          // Jump the gallery to this variant's image (if it has one and the
          // URL is in the product images list — both are rendered at width 800
          // so they match exactly).
          const variant = _modalState.variants.find(v => String(v.id) === String(pill.dataset.variantId));
          if (variant && variant.image && galleryTr && galleryTr.children.length) {
            const idx = _modalState.images.indexOf(variant.image);
            if (idx >= 0) {
              const slideW = galleryTr.children[0].getBoundingClientRect().width;
              if (slideW) {
                stopGalleryAutoplay();
                galleryTr.scrollTo({ left: idx * slideW, behavior: 'smooth' });
                // Resume autoplay after the user has had a moment to look.
                setTimeout(startGalleryAutoplay, 3000);
              }
            }
          }
        });
      }

      // Add to bundle from modal — re-uses the existing onAddClick path
      if (addBtn) {
        addBtn.addEventListener('click', () => {
          const card = _modalState.card;
          if (!card) return;
          // Update card's variant id if user picked a different one in the modal
          if (_modalState.variantId && _modalState.variantId !== card.dataset.variantId) {
            card.dataset.variantId = _modalState.variantId;
          }
          onAddClick(card);
          closeProductModal();
        });
      }
    }

    /** Hide the sticky bar + drawer while the mobile keyboard is up. Without
     *  this, on iOS Safari a `position: fixed; bottom: 0` element sits glued
     *  to the visual-viewport bottom — i.e. directly above the keyboard — and
     *  visually overlaps form fields the shopper is trying to fill in. */
    function bindKeyboardHide() {
      const isTextInput = (el) =>
        el && (el.tagName === 'TEXTAREA' ||
              (el.tagName === 'INPUT' && /^(text|search|email|tel|url|password|number)$/.test(el.type || 'text')));
      root.addEventListener('focusin', (e) => {
        if (isTextInput(e.target)) root.classList.add('bb--kbd-open');
      });
      root.addEventListener('focusout', (e) => {
        if (isTextInput(e.target)) root.classList.remove('bb--kbd-open');
      });
    }

    function bindClear() {
      root.querySelector('[data-bb-clear]')?.addEventListener('click', () => {
        // Full reset — both stages cleared, tier progress reset, and the view
        // returns to stage 1 regardless of where the shopper currently is.
        state.items.clear();
        state.stage2Items.clear();
        state.lastReachedIdx = -1;
        state.manualOffer = null;
        root.querySelectorAll('[data-bb-card]').forEach(syncCardUI);
        setStage('stage1');
      });
    }

    function bindCta() {
      // Stage 1 "Next" CTA — when stage 2 is enabled AND a tier is reached,
      // advance to stage 2 in place. Otherwise commit cart directly (stage 1
      // bundle only).
      root.querySelector('[data-bb-cta]')?.addEventListener('click', onNextClick);
      root.querySelector('[data-bb-cta-mobile]')?.addEventListener('click', onNextClick);
    }

    /** Detect whether stage 2 wiring exists (markup + setting both enabled). */
    function stage2Enabled() {
      return !!root.querySelector('[data-bb-stage-view="2"]');
    }

    function onNextClick() {
      if (state.items.size === 0) return;
      // Already in stage 2 → the click is the Finish action.
      if (state.stage === 'stage2') {
        addBundleToCart();
        return;
      }
      if (stage2Enabled() && state.lastReachedIdx >= 0) {
        setStage('stage2');
      } else {
        addBundleToCart();
      }
    }

    /** Swap the visible stage view. CSS `.bb--stage-2` on the section root
     *  drives the actual show/hide via descendant selectors. */
    function setStage(stage) {
      state.stage = stage;
      const inStage2 = stage === 'stage2';
      root.classList.toggle('bb--stage-2', inStage2);
      // The [data-bb-stage-view] elements use HTML's hidden attr as fallback
      // for browsers that need it; sync it with the active stage.
      root.querySelectorAll('[data-bb-stage-view]').forEach(v => {
        v.hidden = (inStage2 ? v.dataset.bbStageView !== '2' : v.dataset.bbStageView !== '1');
      });
      // Clear any active search so the filter from the previous stage doesn't
      // bleed visibility into the new one. Dispatching `input` re-runs the
      // handler, which restores default visibility for the new stage.
      const searchInput = root.querySelector('[data-bb-search]');
      if (searchInput && searchInput.value) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      // Re-sync all cards (each card reflects its own stage map; ones in the
      // newly-active view need to redraw the stepper if their stage state has
      // entries from previous visits).
      root.querySelectorAll('[data-bb-card]').forEach(syncCardUI);
      scheduleRender();
      // Scroll back to the top of the section so the shopper sees the new
      // header & first row of products without manual scroll.
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function bindStageTransitions() {
      root.querySelector('[data-bb-back]')?.addEventListener('click', () => setStage('stage1'));
      root.querySelector('[data-bb-finish]')?.addEventListener('click', () => {
        // Single commit path — sends both maps; if stage 2 is empty (shopper
        // effectively skipped by not picking anything), only stage 1 ships.
        addBundleToCart();
      });
    }

    function bindDrawer() {
      const open = () => {
        root.classList.add('bb-drawer-open');
        // Lock background scroll while the drawer covers the viewport.
        document.documentElement.dataset.bbScrollLock = '1';
        document.body.style.overflow = 'hidden';
      };
      const close = () => {
        root.classList.remove('bb-drawer-open');
        delete document.documentElement.dataset.bbScrollLock;
        document.body.style.overflow = '';
      };
      root.querySelector('[data-bb-drawer-open]')?.addEventListener('click', open);
      root.querySelector('[data-bb-drawer-close]')?.addEventListener('click', close);
      root.querySelector('[data-bb-backdrop]')?.addEventListener('click', close);
      // Esc closes the drawer
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.classList.contains('bb-drawer-open')) close();
      });
    }

    /** Look up a variant's title from the card's inline JSON blob (the same
     *  data the modal uses). Returns the title for the given variant id, or
     *  null if not found / not multi-variant. */
    function getVariantTitle(card, variantId) {
      const variantsCount = parseInt(card.dataset.variantsCount || '1', 10);
      if (variantsCount <= 1) return null;
      const blob = card.querySelector('[data-bb-card-data]');
      if (!blob) return null;
      try {
        const data = JSON.parse(blob.textContent);
        const v = (data.variants || []).find(v => String(v.id) === String(variantId));
        if (!v || !v.title) return null;
        // Shopify uses "Default Title" for single-option products; skip it.
        if (v.title === 'Default Title') return null;
        return v.title;
      } catch (_) { return null; }
    }

    /* ── Stage helpers ── */
    /** Which stage owns this card — based on its closest ancestor view. */
    function getCardStage(card) {
      const view = card.closest('[data-bb-stage-view]');
      return view && view.dataset.bbStageView === '2' ? 'stage2' : 'stage1';
    }
    function getItemsMapForStage(stage) {
      return stage === 'stage2' ? state.stage2Items : state.items;
    }
    function getCardItemsMap(card) {
      return getItemsMapForStage(getCardStage(card));
    }

    /* ── Card actions ── */
    /** + click: increment qty of that variant (or add at qty 1 if new).
     *  Stage 1 bundle is capped by state.maxQty (largest tier qty). Stage 2
     *  (Add-ons) is uncapped — shopper can add unlimited add-ons. */
    function onAddClick(card) {
      const variantId = card.dataset.variantId;
      if (!variantId) return;
      const stage = getCardStage(card);
      const map = getItemsMapForStage(stage);
      if (stage === 'stage1' && state.maxQty && totalQty() >= state.maxQty) {
        toast(`Bundle is full (${state.maxQty} items max)`);
        return;
      }
      const existing = map.get(variantId);
      if (existing) {
        existing.qty = (existing.qty || 1) + 1;
      } else {
        map.set(variantId, {
          variantId,
          productId: card.dataset.productId,
          handle: card.dataset.handle,
          title: card.dataset.title,
          variantTitle: getVariantTitle(card, variantId),
          price: parseInt(card.dataset.price, 10),
          compare: parseInt(card.dataset.compare, 10),
          image: card.dataset.image,
          qty: 1,
          stage,
        });
      }
      syncCardUI(card);
      scheduleRender();
    }

    /** Decrement qty by 1 (or remove entirely with removeAll: true). The card
     *  argument can be null/undefined — in that case nothing UI-side fires,
     *  but state is still updated (used by the row's trash icon). */
    function onRemoveClick(card, opts) {
      const variantId = card?.dataset?.variantId;
      if (!variantId) return;
      const map = getCardItemsMap(card);
      const existing = map.get(variantId);
      if (!existing) return;
      const removeFully = !!(opts && opts.removeAll);
      const nextQty = removeFully ? 0 : (existing.qty || 1) - 1;
      if (nextQty <= 0) {
        map.delete(variantId);
      } else {
        existing.qty = nextQty;
      }
      if (card) syncCardUI(card);
      scheduleRender();
    }

    /** Is any variant of this card's product currently in the bundle? */
    function isProductInBundle(card) {
      const map = getCardItemsMap(card);
      const pid = String(card.dataset.productId);
      for (const it of map.values()) {
        if (String(it.productId) === pid) return true;
      }
      return false;
    }

    /** Remove every variant of this card's product from the bundle (toggle off). */
    function removeProductFromBundle(card) {
      const map = getCardItemsMap(card);
      const pid = String(card.dataset.productId);
      let changed = false;
      for (const key of [...map.keys()]) {
        if (String(map.get(key).productId) === pid) { map.delete(key); changed = true; }
      }
      if (changed) { syncCardUI(card); scheduleRender(); }
    }

    /* render() is heavy(ish) — coalesce repeated calls within a single frame
     * (rapid + clicks, slot-remove batches, etc.) to avoid re-rendering twice. */
    let _renderQueued = false;
    function scheduleRender() {
      if (_renderQueued) return;
      _renderQueued = true;
      requestAnimationFrame(() => {
        _renderQueued = false;
        render();
      });
    }

    /** Reads from the card's own stage map, so a stage-1 card reflects the
     *  stage-1 state and a stage-2 card the stage-2 state — they don't bleed. */
    function syncCardUI(card) {
      const map = getCardItemsMap(card);
      const pid = String(card.dataset.productId);
      // Product-level toggle: the card reads "Added" if ANY variant of this
      // product is in the bundle (covers multi-variant products added via modal).
      let inBundle = false;
      for (const it of map.values()) {
        if (String(it.productId) === pid) { inBundle = true; break; }
      }
      const addBtn = card.querySelector('[data-bb-add]');
      const lbl    = card.querySelector('[data-bb-add-label]');
      card.classList.toggle('is-selected', inBundle);
      card.dataset.inBundle = inBundle ? '1' : '0';
      if (addBtn) {
        addBtn.classList.toggle('is-added', inBundle);
        addBtn.setAttribute('aria-pressed', inBundle ? 'true' : 'false');
        // Don't relabel a sold-out (disabled) button — it stays "Sold out".
        if (lbl && !addBtn.disabled) {
          lbl.textContent = inBundle
            ? (addBtn.dataset.addedLabel || 'Added')
            : (addBtn.dataset.addLabel || 'Add to Bundle');
        }
      }
    }

    /** Sum of qty across all variants in STAGE 1 (drives tier progress). */
    function totalQty() {
      let total = 0;
      state.items.forEach(it => { total += (it.qty || 1); });
      return total;
    }
    /** Stage 2 total qty — informational only (no tier mechanics). */
    function stage2Qty() {
      let total = 0;
      state.stage2Items.forEach(it => { total += (it.qty || 1); });
      return total;
    }
    /** Stage 2 cart subtotal in paise — for the running total display. */
    function stage2SubtotalCents() {
      let total = 0;
      state.stage2Items.forEach(it => { total += it.price * (it.qty || 1); });
      return total;
    }

    /** Read the stage 2 note form (From / To / Message) and return a formatted
     *  cart-note string, or '' if every field is empty. Sent to /cart/update.js
     *  after the items have been added. */
    function composeCartNote() {
      const fromEl = root.querySelector('[data-bb-note-from]');
      const toEl   = root.querySelector('[data-bb-note-to]');
      const msgEl  = root.querySelector('[data-bb-note-message]');
      const from = (fromEl?.value || '').trim();
      const to   = (toEl?.value   || '').trim();
      const msg  = (msgEl?.value  || '').trim();
      if (!from && !to && !msg) return '';
      const lines = [];
      if (from) lines.push(`From: ${from}`);
      if (to)   lines.push(`To: ${to}`);
      if (msg)  { if (lines.length) lines.push(''); lines.push(msg); }
      return lines.join('\n');
    }

    /* ── Tier helpers ── */
    /** Active offer = max-by-qty between the shopper's manual pick and the
     *  count-derived tier (smallest tier whose qty ≥ current count).
     *  • qty=0, no manual → first tier
     *  • qty=5, no manual → second tier (5 ≤ 6)
     *  • qty=3, manual=last → last tier (manual wins, it's higher)
     *  • qty=7, manual=first → 8-tier (count wins, it's higher) */
    function activeOffer(qty) {
      if (offers.length === 0) return null;
      let countNeeded = offers[offers.length - 1];
      for (const o of offers) {
        if (qty <= o.qty) { countNeeded = o; break; }
      }
      if (state.manualOffer && state.manualOffer.qty > countNeeded.qty) {
        return state.manualOffer;
      }
      return countNeeded;
    }
    function reachedIdx(qty) {
      let idx = -1;
      tiers.forEach((t, i) => { if (qty >= t.qty) idx = i; });
      return idx;
    }

    /* ── Confetti ── */
    function fireConfetti(originEl) {
      if (!state.confettiEnabled) return;
      const anchor = originEl || root.querySelector('[data-bb-progress-fill]');
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;
      const frag = document.createDocumentFragment();
      const particles = [];
      for (let i = 0; i < 28; i++) {
        const p = document.createElement('span');
        p.className = 'bb-confetti';
        const angle = Math.random() * Math.PI * 2;
        const dist  = 70 + Math.random() * 120;
        p.style.cssText =
          'background:' + CONFETTI_COLORS[i % CONFETTI_COLORS.length] + ';' +
          'left:' + x + 'px;top:' + y + 'px;' +
          '--bb-dx:' + (Math.cos(angle) * dist).toFixed(1) + 'px;' +
          '--bb-dy:' + (Math.sin(angle) * dist - 40).toFixed(1) + 'px;' +
          '--bb-rot:' + (Math.random() * 720 - 360).toFixed(0) + 'deg;';
        frag.appendChild(p);
        particles.push(p);
      }
      document.body.appendChild(frag);
      setTimeout(() => particles.forEach(p => p.remove()), 1600);
    }
    /* ── Analytics ── GA4 (gtag) + Meta (fbq) are loaded on the page by GoKwik, so we
       call them directly. Add/remove are DIFFED from one place (bbDiffTrack, run on every
       render) so every mutation path — card toggle, +/- stepper, row trash, clear, prefill —
       is caught exactly once. Checkout (InitiateCheckout / begin_checkout) fires from
       addBundleToCart on the Checkout click. Prices are normalised paise → major units. */
    const BB_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    const _bbPrev = new Map();     // variantId -> { qty, item } snapshot for diffing
    let _bbBaselined = false;
    let _bbSuppress = false;   // set true around the checkout cart-clear so it doesn't fire spurious removes

    function bbItem(it) {
      return {
        variantId: String(it.variantId),
        productId: String(it.productId || ''),
        name: it.title || '',
        variant: it.variantTitle || '',
        handle: it.handle || '',
        price: (parseInt(it.price, 10) || 0) / 100,   // paise → major units (₹)
        quantity: it.qty || 1,
      };
    }
    function bbBundleItems() { return [...state.items.values()].map(bbItem); }
    function bbValue() {
      const offer = activeOffer(totalQty());
      if (offer) return offer.price;                                   // flat tier price (₹)
      return bbBundleItems().reduce((s, i) => s + i.price * i.quantity, 0);
    }
    function bbGa4Items(items) {
      return items.map(i => ({
        item_id: i.variantId, item_name: i.name,
        item_variant: i.variant, price: i.price, quantity: i.quantity,
      }));
    }
    function bbFire(gaName, gaParams, fbType, fbName, fbParams) {
      try { if (typeof window.gtag === 'function') window.gtag('event', gaName, gaParams); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq(fbType, fbName, fbParams); } catch (e) {}
    }
    function bbTrackProduct(action, itLike, qtyDelta) {
      const p = bbItem(itLike);
      p.quantity = qtyDelta || p.quantity || 1;
      const gaName = action === 'add' ? 'add_bundle_product' : 'remove_bundle_product';
      const fbName = action === 'add' ? 'AddBundleProduct'   : 'RemoveBundleProduct';
      bbFire(
        gaName,
        {
          currency: BB_CURRENCY,
          value: p.price * p.quantity,
          bundle_size: totalQty(),
          bundle_max: state.maxQty,
          bundle_value: bbValue(),
          items: bbGa4Items([p]),
        },
        'trackCustom', fbName,
        {
          content_type: 'product',
          content_ids: [p.variantId],
          contents: [{ id: p.variantId, quantity: p.quantity }],
          content_name: p.name,
          value: p.price * p.quantity,
          currency: BB_CURRENCY,
          bundle_size: totalQty(),
        }
      );
    }
    function bbDiffTrack() {
      try {
        const cur = state.items;
        if (!_bbBaselined) {   // first render sets the baseline without firing (ignores prefill)
          _bbBaselined = true;
          cur.forEach((it, vid) => _bbPrev.set(vid, { qty: it.qty, item: Object.assign({}, it) }));
          return;
        }
        if (_bbSuppress) {     // checkout emptied the bundle on purpose — re-baseline, don't fire removes
          _bbSuppress = false;
          _bbPrev.clear();
          cur.forEach((it, vid) => _bbPrev.set(vid, { qty: it.qty, item: Object.assign({}, it) }));
          return;
        }
        cur.forEach((it, vid) => {
          const prevQty = _bbPrev.has(vid) ? _bbPrev.get(vid).qty : 0;
          if (it.qty > prevQty) bbTrackProduct('add', it, it.qty - prevQty);
          else if (it.qty < prevQty) bbTrackProduct('remove', it, prevQty - it.qty);
        });
        _bbPrev.forEach((prev, vid) => {
          if (!cur.has(vid)) bbTrackProduct('remove', prev.item, prev.qty);
        });
        _bbPrev.clear();
        cur.forEach((it, vid) => _bbPrev.set(vid, { qty: it.qty, item: Object.assign({}, it) }));
      } catch (e) {}
    }

    /* ── Render ── */
    function render() {
      bbDiffTrack();
      const qty   = totalQty();
      const offer = activeOffer(qty);
      const ridx  = reachedIdx(qty);
      const reached = ridx >= 0 ? tiers[ridx] : null;

      // Keep every card's Add / Added toggle in sync with the current bundle state.
      root.querySelectorAll('[data-bb-card]').forEach(syncCardUI);

      // Offer pill highlight — sync ALL [data-bb-offer] elements (desktop + mobile)
      root.querySelectorAll('[data-bb-offer]').forEach(el => {
        const qty = parseInt(el.dataset.qty, 10);
        const sel = !!offer && qty === offer.qty;
        el.classList.toggle('is-selected', sel);
        el.setAttribute('aria-checked', sel ? 'true' : 'false');
      });

      // Progress fill — there can be more than one (right-pane slider + sticky-bar mini slider)
      const fillEls = [...root.querySelectorAll('[data-bb-progress-fill]')];
      const fill = fillEls[0]; // canonical one for the calc below
      if (fill && tiers.length) {
        // Tier marker positions on the track. MUST match the Liquid formula
        // used to render the .bb-tiers-stop / .bb-stickybar-stop `left:` values
        // — otherwise the fill bar over/undershoots the marker circle.
        const n = tiers.length;
        const stopPct = (i) => (n === 1 ? 100 : 35 + (i / (n - 1)) * 65);
        let pct;
        if (ridx === n - 1) {
          pct = 100;
        } else if (ridx === -1) {
          const first = tiers[0];
          const frac = first.qty > 0 ? Math.min(qty / first.qty, 1) : 0;
          pct = frac * stopPct(0);
        } else {
          const a = tiers[ridx].qty;
          const b = tiers[ridx + 1].qty;
          const frac = b > a ? (qty - a) / (b - a) : 0;
          pct = stopPct(ridx) + frac * (stopPct(ridx + 1) - stopPct(ridx));
        }
        const pctStr = Math.max(0, Math.min(100, pct)) + '%';
        fillEls.forEach(el => { el.style.width = pctStr; });
      }

      tiers.forEach((t) => {
        t.el.classList.toggle('is-hit', qty >= t.qty);
      });

      // Sticky-bar mini stops mirror is-hit by qty (separate elements, no data-bb-tier)
      root.querySelectorAll('.bb-stickybar-stop[data-qty]').forEach(el => {
        const tierQty = parseInt(el.dataset.qty, 10);
        el.classList.toggle('is-hit', qty >= tierQty);
      });

      // Confetti on upward tier crossing — pick a *visible* anchor.
      // Mobile + drawer closed → sticky-bar mini stop (right pane is off-screen).
      // Mobile + drawer open OR desktop → desktop tier element.
      if (ridx > state.lastReachedIdx && ridx >= 0) {
        const justHit = tiers[ridx];
        const isMobile = window.matchMedia('(max-width: 989px)').matches;
        const drawerOpen = root.classList.contains('bb-drawer-open');
        const useMini = isMobile && !drawerOpen;

        let burstAt = null;
        if (useMini && justHit) {
          // Sticky-bar stop is an icon-in-circle (matches desktop). Earlier this
          // queried .bb-stickybar-stop-dot which no longer exists in the DOM.
          burstAt = root.querySelector(`.bb-stickybar-stop[data-qty="${justHit.qty}"] .bb-stickybar-stop-icon`);
        }
        if (!burstAt && justHit && justHit.el) {
          burstAt = justHit.el.querySelector('.bb-stop-icon');
        }
        if (!burstAt) {
          // Fallback to whichever progress-fill is visible
          burstAt = useMini
            ? root.querySelector('.bb-stickybar [data-bb-progress-fill]')
            : root.querySelector('.bb-tiers [data-bb-progress-fill]');
        }
        fireConfetti(burstAt);
      }
      state.lastReachedIdx = ridx;

      // Status block — heading + outlined message + lock/check icon.
      // Locked = active offer not yet reached; Unlocked = qty >= active offer qty.
      const statusBlockEl = root.querySelector('[data-bb-statusblock]');
      const statusEl = root.querySelector('[data-bb-status]');
      const statusTextEl = root.querySelector('[data-bb-status-text]');
      if (statusBlockEl && statusEl && statusTextEl) {
        const tplProgress = root.dataset.statusTemplateProgress
          || 'Add {count} more product(s) to claim {save}';
        const tplDone     = root.dataset.statusTemplateDone
          || "Congrats — you're eligible for {save}!";
        if (!offer) {
          statusBlockEl.hidden = true;
        } else {
          const unlocked = qty >= offer.qty;
          const vars = {
            count: String(Math.max(0, offer.qty - qty)),
            tier:  offer.title,
            save:  offer.save,
            price: fmt(offer.price * 100),
          };
          statusTextEl.textContent = subst(unlocked ? tplDone : tplProgress, vars);
          statusEl.classList.toggle('is-unlocked', unlocked);
          statusBlockEl.hidden = false;
        }
      }

      // Slot list — render each in-bundle variant as a horizontal row
      // (thumb · title + price · ×qty badge · trash). Empty rows render as
      // skeleton placeholders (dashed thumb + grey bars) and are capped at 2
      // regardless of remaining tier capacity — keeps the right pane visually
      // calm even for a Box-of-8 bundle that's nearly empty.
      const slots = root.querySelector('[data-bb-slots]');
      const isStage2 = state.stage === 'stage2';
      if (slots) {
        slots.innerHTML = '';
        // Right pane always shows BOTH maps regardless of stage — gives the
        // shopper a continuous view of their full selection as they move
        // between stages. Each item carries a `stage` property added at
        // insert-time so the trash handler knows which map to mutate.
        const items = [...state.items.values(), ...state.stage2Items.values()];

        items.forEach(it => {
          const li = document.createElement('li');
          const itemStage = it.stage === 'stage2' ? 'stage2' : 'stage1';
          li.className = 'bb-slot bb-slot--filled bb-slot--' + itemStage;
          li.dataset.qty = it.qty || 1;
          li.dataset.stage = itemStage;
          const displayTitle = it.variantTitle
            ? `${it.title} / ${it.variantTitle}`
            : it.title;
          li.innerHTML = `
            <img class="bb-slot-thumb" src="${escapeAttr(it.image)}" alt="${escapeAttr(displayTitle)}" loading="lazy" decoding="async">
            <div class="bb-slot-meta">
              <p class="bb-slot-title">${escapeAttr(displayTitle)}</p>
              <p class="bb-slot-price">${fmt(it.price)}</p>
            </div>
            <span class="bb-slot-qty">x${it.qty || 1}</span>
            <button type="button" class="bb-slot-remove" aria-label="Remove ${escapeAttr(it.title)} from bundle">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6"/>
                <path d="M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>`;
          li.querySelector('.bb-slot-remove').addEventListener('click', () => {
            const map = itemStage === 'stage2' ? state.stage2Items : state.items;
            map.delete(it.variantId);
            // Card for this variant may live in either stage view; sync any match.
            root.querySelectorAll(`[data-bb-card][data-variant-id="${it.variantId}"]`).forEach(syncCardUI);
            scheduleRender();
          });
          slots.appendChild(li);
        });

        // Placeholder rows hint at "more bundle items needed for a tier".
        // Only relevant during stage 1 while the shopper is still working
        // toward an active offer. Stage 2 is unbounded add-on territory — no
        // placeholders there (their bundle is already complete).
        let placeholderCount = 0;
        if (!isStage2) {
          const stage1Qty = qty;
          const target = offer ? offer.qty : Math.max(stage1Qty + 2, 2);
          const remaining = Math.max(0, target - stage1Qty);
          placeholderCount = Math.min(remaining, 2);
        }
        for (let i = 0; i < placeholderCount; i++) {
          const li = document.createElement('li');
          li.className = 'bb-slot bb-slot--empty';
          li.innerHTML = `
            <span class="bb-slot-thumb-skel" aria-hidden="true"></span>
            <div class="bb-slot-meta-skel" aria-hidden="true">
              <span class="bb-slot-bar bb-slot-bar--long"></span>
              <span class="bb-slot-bar bb-slot-bar--short"></span>
            </div>
            <span class="bb-slot-qty-skel" aria-hidden="true"></span>`;
          slots.appendChild(li);
        }
      }

      // Item count — combined across both stages so the rendered row count matches
      const countEl = root.querySelector('[data-bb-count]');
      if (countEl) countEl.textContent = qty + stage2Qty();

      // Add-on eligibility pill — always visible; no JS toggle. The pill is
      // rendered whenever stage 2 is enabled in section settings.

      // Total — grand-total across BOTH stages, regardless of which view is active.
      // Stage 1 contribution = tier flat price if a tier is reached, otherwise
      // the running stage-1 subtotal. Stage 2 contribution = sum of stage 2
      // items at their already-discounted variant prices. The strike-through
      // shows the pre-tier-discount total (stage 1 subtotal + stage 2 sum)
      // only when a tier is actually saving the shopper money.
      const totalEl       = root.querySelector('[data-bb-total]');
      const totalStrikeEl = root.querySelector('[data-bb-total-strike]');
      let stage1Subtotal = 0;
      state.items.forEach(it => stage1Subtotal += (it.price * (it.qty || 1)));
      const stage2Cents = stage2SubtotalCents();

      let headlineCents;
      let showStrike = false;
      if (qty === 0 && stage2Qty() === 0) {
        headlineCents = 0;
      } else if (reached && (reached.price * 100) < stage1Subtotal) {
        headlineCents = (reached.price * 100) + stage2Cents;
        showStrike = true;
      } else {
        headlineCents = stage1Subtotal + stage2Cents;
      }
      if (totalEl) totalEl.textContent = fmt(headlineCents);
      if (totalStrikeEl) {
        if (showStrike) {
          totalStrikeEl.textContent = fmt(stage1Subtotal + stage2Cents);
          totalStrikeEl.hidden = false;
        } else {
          totalStrikeEl.textContent = '';
          totalStrikeEl.hidden = true;
        }
      }
      const finalCents = headlineCents;

      // CTAs
      const cta        = root.querySelector('[data-bb-cta]');
      const ctaLabel   = root.querySelector('[data-bb-cta-label]');
      const ctaMobile  = root.querySelector('[data-bb-cta-mobile]');
      const ctaMobileL = root.querySelector('[data-bb-cta-mobile-label]');
      const target = offer ? offer.qty : 0;
      let txt, disabled;
      const ctaDefault = root.dataset.ctaLabel || 'Next';
      if (qty === 0) { txt = ctaDefault; disabled = true; }
      else if (qty < target) { txt = `Add ${target - qty} more`; disabled = true; }
      else { txt = ctaDefault; disabled = false; }
      if (cta && ctaLabel)         { ctaLabel.textContent = txt;        cta.disabled = disabled; }
      if (ctaMobile && ctaMobileL) {
        // In stage 2 the mobile CTA is the Finish button — mirror the label of
        // the desktop Finish button and stay enabled as long as stage 1 has items.
        if (state.stage === 'stage2') {
          const finishBtn = root.querySelector('[data-bb-finish]');
          ctaMobileL.textContent = (finishBtn && finishBtn.textContent.trim()) || 'Add bundle to cart';
          ctaMobile.disabled = qty === 0;
        } else {
          ctaMobileL.textContent = txt;
          ctaMobile.disabled = disabled;
        }
      }

      // Mobile sticky bar — count + status text + CTA price/strike
      // Count is rendered in 2 places: the open pill (sticky bar) AND the
      // close pill (drawer's top edge). Both carry data-bb-sticky-count.
      const sCounts      = root.querySelectorAll('[data-bb-sticky-count]');
      const sStatus      = root.querySelector('[data-bb-sticky-status]');
      const sStatusWrap  = root.querySelector('[data-bb-sticky-statuswrap]');
      const sCtaPrice    = root.querySelector('[data-bb-cta-mobile-price]');
      const sCtaStrike   = root.querySelector('[data-bb-cta-mobile-strike]');
      // Also handle the legacy data-bb-sticky-total / data-bb-sticky-tier if either
      // remains in custom theme overrides — silent if absent.
      const sTotalLegacy = root.querySelector('[data-bb-sticky-total]');

      // Mobile floating pills (open + close) mirror the right-pane "N item(s)"
      // header, which is the combined total across both stages.
      const stickyDisplayQty = qty + stage2Qty();
      sCounts.forEach(el => { el.textContent = stickyDisplayQty; });

      if (sStatus) {
        if (qty > 0 && statusTextEl && statusTextEl.textContent) {
          sStatus.textContent = statusTextEl.textContent;
        } else {
          sStatus.textContent = root.dataset.summaryTitle || 'Your bundle';
        }
      }
      if (sStatusWrap) {
        // Switches the lock icon to the check icon and the pill to green
        const unlocked = !!offer && qty >= offer.qty;
        sStatusWrap.classList.toggle('is-unlocked', unlocked);
        sStatusWrap.classList.toggle('is-idle', qty === 0);
      }

      if (sCtaPrice) sCtaPrice.textContent = fmt(finalCents);
      if (sCtaStrike) {
        if (showStrike) {
          // Pre-tier-discount total = stage 1 subtotal + stage 2 sum (same
          // value the desktop strike-through uses a few blocks above).
          sCtaStrike.textContent = fmt(stage1Subtotal + stage2Cents);
          sCtaStrike.hidden = false;
        } else {
          sCtaStrike.textContent = '';
          sCtaStrike.hidden = true;
        }
      }

      if (sTotalLegacy) {
        sTotalLegacy.textContent = qty === 0
          ? (root.dataset.summaryTitle || 'Your bundle')
          : `Total ${fmt(finalCents)}`;
      }
    }

    /* ── Cart submit ──
       Merges stage 1 + stage 2 into one POST. Stage 1 lines carry
       `_bundle: byob` (the tier-discounted bundle items); stage 2 lines carry
       `_bundle: upsell` (the already-discounted add-ons). Stage 2 auto-
       included whenever it has items — no explicit Skip flow. */
    async function addBundleToCart() {
      if (state.items.size === 0) return;
      const includeStage2 = state.stage2Items.size > 0;
      const cta        = root.querySelector('[data-bb-cta]');
      const ctaLabel   = root.querySelector('[data-bb-cta-label]');
      const ctaMobileL = root.querySelector('[data-bb-cta-mobile-label]');
      const finishBtn  = root.querySelector('[data-bb-finish]');
      const original = ctaLabel?.textContent;
      const originalFinish = finishBtn?.textContent;
      if (cta) cta.disabled = true;
      if (ctaLabel)   ctaLabel.textContent   = 'Adding…';
      if (ctaMobileL) ctaMobileL.textContent = 'Adding…';
      if (finishBtn)  { finishBtn.disabled = true; finishBtn.textContent = 'Adding…'; }

      const offer = activeOffer(totalQty());
      const stage1 = [...state.items.values()].map(it => ({
        id: parseInt(it.variantId, 10),
        quantity: it.qty || 1,
        properties: {
          _bundle: 'byob',
          _bundle_qty: totalQty(),
          _bundle_offer: offer ? `${offer.qty}-pack @ ${fmt(offer.price * 100)}` : '',
        },
      }));
      const stage2 = includeStage2 ? [...state.stage2Items.values()].map(it => ({
        id: parseInt(it.variantId, 10),
        quantity: it.qty || 1,
        properties: {
          _bundle: 'upsell',
          _bundle_addon_for: offer ? `${offer.qty}-pack` : '',
        },
      })) : [];
      const items = [...stage1, ...stage2];

      try {
        // Clear any existing cart contents first — the bundle is the new cart,
        // not an addition. Ensures the cart only contains the bundle products
        // (no leftover items from prior shopping).
        const clearRes = await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        });
        if (!clearRes.ok) throw new Error('Cart clear failed');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('Add to cart failed');

        // Stage 2 note → cart-level note via /cart/update.js. Non-fatal if it
        // fails — the items are already in the cart.
        const noteText = composeCartNote();
        if (noteText) {
          try {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ note: noteText }),
            });
          } catch (noteErr) { console.warn('Cart note update failed', noteErr); }
        }

        toast('Bundle added to cart');
        document.dispatchEvent(new CustomEvent('bb:added', { detail: { items, offer, stage2Included: includeStage2, note: noteText } }));
         // Refresh the cart snapshot GoKwik checks out against. GoKwik captures
        // `window.cart` at page load (snippets/gokwik.liquid); on the bundle page that
        // snapshot is empty, so overwrite it with the freshly-built cart before opening
        // GoKwik checkout — otherwise the checkout can open empty.

        try {
          const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          if (cartRes.ok) window.cart = await cartRes.json();
        } catch (_) { /* non-fatal */ }
        if (typeof window.closeGokwikSideCart === 'function') {
          try { window.closeGokwikSideCart(); } catch (_) {}
        }
        _bbSuppress = true;   // cart is built; clearing the client bundle now must NOT fire remove events
        state.items.clear();
        state.stage2Items.clear();
        state.lastReachedIdx = -1;
        state.manualOffer = null;
        setStage('stage1');
        root.querySelectorAll('[data-bb-card]').forEach(syncCardUI);
        scheduleRender();
        // Direct checkout: open GoKwik straight away with the bundle in the cart.
        // The CTA is no longer a GoKwik-hijacked "Checkout" button, so this handler
        // actually runs and the items are really in the cart; window.cart was just
        // refreshed above. Fall back to Shopify's native checkout if the GoKwik SDK
        // isn't present — either way we go straight to a checkout, no cart page.
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
          window.gokwikSdk.initCheckout(window.merchantInfo);
        } else {
          window.location.href = "/checkout";
        }
      } catch (err) {
        console.error(err);
        toast('Could not add bundle. Try again.');
      } finally {
        if (cta) cta.disabled = false;
        if (ctaLabel && original)         ctaLabel.textContent   = original;
        if (ctaMobileL && original)       ctaMobileL.textContent = original;
        if (finishBtn) { finishBtn.disabled = false; if (originalFinish) finishBtn.textContent = originalFinish; }
      }
    }

    function toast(msg) {
      const el = root.querySelector('[data-bb-toast]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(el._t);
      el._t = setTimeout(() => { el.hidden = true; }, 2500);
    }
  }

  function subst(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, (_, key) => (vars[key] != null ? vars[key] : ''));
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const value = (Math.round(cents) / 100).toFixed(2);
    const [whole, frac] = value.split('.');
    const wholeFormatted = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formatted = `${wholeFormatted}.${frac}`;
    return format.replace(placeholderRegex, (_, key) => {
      if (key === 'amount_no_decimals') return wholeFormatted;
      if (key === 'amount_with_comma_separator') return formatted.replace('.', ',');
      return formatted;
    });
  }

  function escapeAttr(s) {
    return String(s || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
})();
